import Contact from '../components/Contact/Contact';

const ContactScreen = () => <Contact />;

export default ContactScreen;
